import { runInAction } from "mobx";
import { useTranslation } from "react-i18next";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Checkbox from "../../Styled/Checkbox";
import Text from "../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableDimensionCheckbox = _ref => {
  var _dim$options$find$nam, _dim$options;
  let {
    id,
    dim
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Checkbox, {
    name: id,
    isChecked: dim.selectedId === "true",
    onChange: evt => runInAction(() => dim.setDimensionValue(CommonStrata.user, evt.target.checked ? "true" : "false")),
    children: /*#__PURE__*/_jsx(Text, {
      children: (_dim$options$find$nam = (_dim$options = dim.options) === null || _dim$options === void 0 || (_dim$options = _dim$options.find(opt => opt.id === dim.selectedId)) === null || _dim$options === void 0 ? void 0 : _dim$options.name) !== null && _dim$options$find$nam !== void 0 ? _dim$options$find$nam : dim.selectedId === "true" ? t("selectableDimensions.enabled") : t("selectableDimensions.disabled")
    })
  });
};